import { Box, Card, Divider, Image, Text } from '@doist/marketist';
import cn from 'clsx';
import css from './icon-card.module.css';
export type IconCardProps = {
  title: string;
  description: string;
  tintColor?: string;
  image: {
    src: string;
    alt?: string;
    size?: number;
  };
  link: {
    href: string;
    target?: HTMLAnchorElement['target'];
  };
  accessoryView?: React.ReactNode;
  variant?: 'base' | 'lg' | 'integration';
};
export function IconCard({
  title,
  description,
  image,
  accessoryView,
  tintColor,
  link,
  variant = 'base'
}: IconCardProps) {
  const imageSize = image.size ?? (variant === 'base' ? 100 : variant === 'lg' ? 128 : 73);
  return <Card className={cn(css.iconCard, css[variant])} data-sentry-element="Card" data-sentry-component="IconCard" data-sentry-source-file="icon-card.tsx">
            <Box className={css.imageContainer} style={tintColor ? {
      '--bg-color': tintColor
    } : undefined} data-sentry-element="Box" data-sentry-source-file="icon-card.tsx">
                <Image src={image.src} width={imageSize} height={imageSize} alt={image.alt ?? ''} data-sentry-element="Image" data-sentry-source-file="icon-card.tsx" />
            </Box>
            <Divider data-sentry-element="Divider" data-sentry-source-file="icon-card.tsx" />
            <Text size={variant === 'base' ? 'minor-base' : 'major-sm'} weight={variant === 'base' ? 'semibold' : undefined} className="pbs-16 pbe-8 pi-16" data-sentry-element="Text" data-sentry-source-file="icon-card.tsx">
                <a className={css.link} {...link}>
                    {title}
                </a>
            </Text>
            <Text size={variant === 'base' ? 'body-xs' : 'body-sm'} weight={variant === 'base' ? 'medium' : undefined} className={cn(css.description, 'pi-16 pbe-16')} data-sentry-element="Text" data-sentry-source-file="icon-card.tsx">
                {description}
            </Text>
            {accessoryView ? <Box className={cn({
      [css.topRight]: variant === 'integration',
      'pi-16 pbe-16': variant !== 'integration'
    })}>
                    {accessoryView}
                </Box> : null}
        </Card>;
}